import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import * as wjRNav from "@grapecity/wijmo.react.nav"
import * as wjCNav from "@grapecity/wijmo.nav"
import { useLocation, withRouter } from "react-router"
import queryString from "query-string"
import QueryEditor from "./QueryEditor"
import AlertComponent from "../../../components/AlertComponent"
import { useParams } from "react-router-dom"
import QueryResult from "./QueryResult"
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"
import { clearAlert } from "../../../globalStore/alertStore"

/**
 * AyanasQuery
 * @returns
 */
const AyanasQueryQuery = () => {
  // ID取得
  const { queryId: id } = useParams<{ queryId: string }>()
  const location = useLocation()
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  const query: { run?: string } = queryString.parse(location.search)

  const firstIndex = query != null && query.run === "1" ? 1 : 0
  const [selectedIndex, setSelectedIndex] = useState(firstIndex)
  const is更新 = id ? true : false

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  const selectTab = (tabIndex: number) => {
    setSelectedIndex(tabIndex)
  }

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">AyanasQuery クエリ</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col className="pt-2">
          <wjRNav.TabPanel
            className={"no-background-color-tab"}
            selectedIndexChanged={(tabPanel: wjCNav.TabPanel) => {
              setSelectedIndex(tabPanel.selectedIndex)

              //タブ遷移時にエラーメッセージを削除する
              dispatch(clearAlert())
            }}
            selectedIndex={selectedIndex}>
            <wjRNav.Tab>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a>クエリエディタ</a>
              <QueryEditor tabChangeHandler={selectTab}></QueryEditor>
            </wjRNav.Tab>
            <wjRNav.Tab isDisabled={!is更新}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a>クエリ実行</a>
              <QueryResult tabIndex={selectedIndex}></QueryResult>
            </wjRNav.Tab>
          </wjRNav.TabPanel>
        </Col>
      </Row>
    </Container>
  )
}

export default withRouter(AyanasQueryQuery)
